import { render, staticRenderFns } from "./LiteVideoPlayer.vue?vue&type=template&id=724a8c88&scoped=true"
import script from "./LiteVideoPlayer.vue?vue&type=script&lang=js"
export * from "./LiteVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./LiteVideoPlayer.vue?vue&type=style&index=0&id=724a8c88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724a8c88",
  null
  
)

export default component.exports